// extracted by mini-css-extract-plugin
export default {"grid":"VideoBlockTwo_grid__gsYy3","container":"VideoBlockTwo_container__keSml","video":"VideoBlockTwo_video__Fnm9T","caption":"VideoBlockTwo_caption__ECLJU"};